

import { Badge, Callout, Card, Flex, Tabs, Text } from '@radix-ui/themes';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import { useAppDispatch } from '../../../hooks/hooks';
import { useGetPaymentReferencesQuery } from '../../../hooks/useGetPaymentReferencesQuery';
import { useGetStudentDebtiesQuery, useGetStudentDebtsTotalByStudentIdQuery } from '../../../hooks/useGetStudentDebtiesQuery';
import { useGetTeacheIdByUserId } from '../../../hooks/useGetTeacheIdByUserId';
import { RootState } from '../../../redux/store';
import { routes } from '../../../routes';
import { StudentDebtType } from '../../../types/Finance';
import { BellIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { getStudentDebt } from '../../../services/finance/studentDebt';
import { useGetSchoolBankConfigQuery } from '../../../hooks/useGetSchoolBankConfigQuery';
import { PAGE_NUMBER } from '../../../utils/constants';
import { getStudentById } from '../../../services/school/student/getStudentByCode';
import { getUserById } from '../../../services/user/getUsers';
import { setStudentData } from '../../../redux/slices/school/student';
import { setStudentDebtData } from '../../../redux/slices/finance/studentDebt';
import { setPdfPreviewType } from '../../../redux/slices/report/report';
import { setUserData } from '../../../redux/slices/users/user';
import { printInvoice, SchoolBankConfig } from './printInvoice';
import { useExportDocument } from '../../../hooks/useExportDocument';
import { useIES } from '../../../hooks/useIES';
import { useLogoBase64 } from '../../../hooks/useLogoBase64';
type ActiveSegmentTab = 'totalStudentDebts' | 'studentDebts' | 'paymentReferences' | 'payed';
const columnNamesMapStudentDebt: { [key: string]: string } = {
  paymentType: "Tipo de emolumento",
  originalAmount: "Valor a pagar",
  currentAmount: "Valor remanescente",
  dueDate: "Ate data a pagar",
  month: "Mês",
  description: "Descrição",
  isPayedIcon: "Pago ?",
};
const columnNamesMapPaymentReference: { [key: string]: string } = {
  paymentType: "Tipo de emolumento",
  referenceCode: "Ref.",
  entity: "Entidade",
  amount: "Valor",
  dueDate: "Ate data a pagar",
  isPayedIcon: "Pago ?",
};
export const GetStudentFinanceState = () => {
  const [currentPage, setCurrentPage] = useState(PAGE_NUMBER);
  const [activeSegment, setActiveSegment] = useState<ActiveSegmentTab>('totalStudentDebts');
  const loggedUserData = useSelector((state: RootState) => state.login.userData)
  const queryClient = useQueryClient();
  const { UserId } = useSelector((state: RootState) => state.login.userData);
  const { data: studentData, isLoading: isLoadingStudentData } = useGetTeacheIdByUserId(UserId);
  const [currentPageStudentDebt, setCurrentPageStudentDebt] = useState(1);
  const [currentPagePaymentReferences, setCurrentPagePaymentReferences] = useState(1);
  const { data: studentDebtsData, refetch: fetchStudentDebts, status: studentDebtsStatus } = useGetStudentDebtiesQuery({ PageNumber: 1, PageSize: 4000, IdStudent: studentData?.idStudent },
    {
      enabled: !!studentData?.idStudent
    }
  )
  const { data: paymentReferencesData, refetch: fetchPaymentReferences, status: paymentReferencesStatus } = useGetPaymentReferencesQuery({ PageNumber: 1, PageSize: 4000, IdStudent: studentData?.idStudent },
    {
      enabled: !!studentData?.idStudent
    }
  )
  const { data: studentDebtsTotalsData } = useGetStudentDebtsTotalByStudentIdQuery(studentData?.idStudent,
    {
      enabled: !!studentData?.idStudent
    }
  )
  const navigateAndValidate = (tabToNavigateTo: ActiveSegmentTab) => {
    if (activeSegment !== tabToNavigateTo) setActiveSegment(tabToNavigateTo);
  }
  const studentDebtsNotPayed = studentDebtsData?.items.filter(sd => !sd.isPayed && sd.idStudent === studentData?.idStudent);
  const studentDebtsPayed = studentDebtsData?.items.filter(sd => sd.isPayed && sd.idStudent === studentData?.idStudent);
  const studentPaymentReferences = paymentReferencesData?.items.filter(sd => sd.idStudent === studentData?.idStudent);
  const totalDebts = studentDebtsTotalsData?.totalDebt;
  const handlePageChangeStudentDebt = (page: number) => {
    setCurrentPageStudentDebt(page);
  };
  const handlePageChangePaymentReference = (page: number) => {
    setCurrentPagePaymentReferences(page);
  };
  const dispatch = useAppDispatch();
   const { IES } = useIES();
    const { logoBase64 } = useLogoBase64();
    const { exportDocumentPdf } = useExportDocument();
  const navigate = useNavigate();
  const { data: schoolBankConfigsData, status: schoolBankConfigsStatus } = useGetSchoolBankConfigQuery({ PageNumber: currentPage, PageSize: 400 });
   const schoolBankConfigsArray: SchoolBankConfig[] = schoolBankConfigsData?.items.map(i => ({
  bankEntity: i.bankEntity!,
  bankName: i.bankName!
})) ?? [];
  const handlePrintInvoice = async (c: StudentDebtType) => {
    try {
      const studentDebtDataRequest = await getStudentDebt({ PageSize: 1, PageNumber: 1, Id: c.id });
      const paymentReferences = studentDebtDataRequest?.items
        .flatMap((sdr) => sdr.paymentReferences || [])
        .filter((ref) => ref?.id)
        .filter((ref) => ref.status);
      let studentDebt = studentDebtDataRequest?.items?.at(0)!;
      const paymentReference = paymentReferences?.find(p => p.amount === studentDebt.originalAmount);
      if (paymentReference) {
        studentDebt.entityCode = paymentReference.entity;
        studentDebt.referenceCode = paymentReference.referenceCode;
        studentDebt.bankDescription = schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankDescription ?? schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankName ?? "";
        studentDebt.bankName = schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankName ?? "";
      }
      try {
        const studentData = await getStudentById(studentDebt.idStudent);
        const userData = await getUserById(studentData.idUser)
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        console.error(error)
      }
       dispatch(setStudentDebtData(studentDebt))
      // dispatch(setPdfPreviewType('INVOICE'))
      // navigate(routes.pdfPreview)
      await printInvoice({
              studentDebtId: studentDebt.id!,
              schoolBankConfigsData: schoolBankConfigsArray,
              IES,
              logoBase64: logoBase64 ?? undefined,
              exportDocument: exportDocumentPdf,
               loggedUserData: loggedUserData,
              dispatch,
            });
    } catch (error) {
      console.error(error)
    }
  }

  const options = studentDebtsNotPayed?.map(() => [
    {
      label: 'Imprimir cobrança',
      onClick: (c: StudentDebtType) => handlePrintInvoice(c),
      icon: <BellIcon />
    }
  ]) || [];


  if (!studentData || !studentData.idStudent) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>
            Entre como estudante&nbsp;
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Callout.Text>
        </Callout.Root>

      </Flex>
    );
  }

  return (
    <Card size='1'>
      <Flex direction='column' gap='4'>
        <Tabs.Root value={activeSegment}
          onValueChange={(tabToNavigate) => {
            navigateAndValidate(tabToNavigate as ActiveSegmentTab);
          }}
        >
          <Tabs.List>
            <Tabs.Trigger value="totalStudentDebts">Total em dividas</Tabs.Trigger>
            <Tabs.Trigger value="payed">Pagamentos</Tabs.Trigger>
            <Tabs.Trigger value="studentDebts">Cobranças</Tabs.Trigger>
            <Tabs.Trigger value="paymentReferences">Referências</Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value="totalStudentDebts">
            <Flex p='4' align='center'>
              <Text size='2'>Cobranças:</Text> <Text color='red' weight='bold' ml='1'>
                {
                  totalDebts?.toFixed(2)
                }Mtn
              </Text>
            </Flex>
          </Tabs.Content>
          <Tabs.Content value="payed">
            <>
              <Lists
                status={studentDebtsStatus}
                TableComponent={() =>
                  <TableComponent
                    columns={Object.keys(columnNamesMapStudentDebt)}
                    items={studentDebtsPayed?.map(item => {
                      return {
                        ...item,
                        isPayedIcon: item.isPayed ? <><Badge color="green">
                          Pago
                        </Badge> </> :
                          <Badge color="red">
                            Não pago
                          </Badge>
                      }
                    })}
                    options={[]}
                    columnNamesMap={columnNamesMapStudentDebt}
                    totalPages={studentDebtsPayed?.length || 1}
                    currentPage={currentPageStudentDebt}
                    onPageChange={handlePageChangeStudentDebt}
                  />
                }
                handleClickCreate={undefined}
              />
            </>
          </Tabs.Content>
          <Tabs.Content value="studentDebts">
            <>
              <Lists
                status={studentDebtsStatus}
                TableComponent={() =>
                  <TableComponent
                    columns={Object.keys(columnNamesMapStudentDebt)}
                    items={studentDebtsNotPayed?.map(item => {
                      return {
                        ...item,
                        isPayedIcon: item.isPayed ? <><Badge color="green">
                          Pago
                        </Badge> </> :
                          <Badge color="red">
                            Não pago
                          </Badge>
                      }
                    })}
                    options={options}
                    columnNamesMap={columnNamesMapStudentDebt}
                    totalPages={studentDebtsNotPayed?.length || 1}
                    currentPage={currentPageStudentDebt}
                    onPageChange={handlePageChangeStudentDebt}
                  />
                }
                handleClickCreate={undefined}
              />
            </>
          </Tabs.Content>
          <Tabs.Content value="paymentReferences">
            <Lists
              status={paymentReferencesStatus}
              TableComponent={() =>
                <TableComponent
                  columns={Object.keys(columnNamesMapPaymentReference)}
                  items={studentPaymentReferences?.map(item => {
                    return {
                      ...item,
                      isPayedIcon: item.isPayed ? <><Badge color="green">
                        Pago
                      </Badge> </> :
                        <Badge color="red">
                          Não pago
                        </Badge>
                    }
                  })}
                  options={[]}
                  columnNamesMap={columnNamesMapPaymentReference}
                  totalPages={studentPaymentReferences?.length || 1}
                  currentPage={currentPagePaymentReferences}
                  onPageChange={handlePageChangePaymentReference}
                />
              }
              handleClickCreate={undefined}
            />
          </Tabs.Content>
        </Tabs.Root>
      </Flex>
    </Card>
  )
}

